var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Dark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 932,
    viewBox: "0 0 1000 932",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1000 0H0V931.17H1000V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M785.979 234.8C789.509 239.53 788.249 248.21 784.139 255.64L783.769 256.3C781.229 260.65 777.769 264.53 773.719 266.86L619.209 356.04C615.169 358.39 611.659 358.54 609.139 357.07L608.789 356.86C604.679 354.18 603.399 346.98 606.929 338.14L684.209 144.46C684.829 142.91 685.549 141.43 686.359 140L686.399 139.94L686.459 139.86C691.829 130.64 700.609 125.42 706.129 128.11C707.099 128.58 707.979 129.31 708.719 130.32L785.979 234.77V234.8ZM706.889 192.5V187.67C706.889 181.05 702.209 178.36 696.469 181.69C690.709 185.01 686.049 193.06 686.049 199.72V204.53L689.579 251.43L703.469 243.4L706.899 192.49L706.889 192.5ZM703.879 278.26C705.879 274.79 706.889 271.39 706.889 268.03C706.889 264.67 705.879 262.44 703.879 261.28C701.899 260.1 699.419 260.39 696.509 262.06C693.619 263.75 691.169 266.29 689.159 269.78C687.159 273.23 686.169 276.65 686.169 279.99C686.169 283.33 687.179 285.58 689.159 286.76C691.159 287.92 693.619 287.65 696.509 286C699.419 284.33 701.879 281.73 703.879 278.26Z",
    fill: "#FBB93E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M706.89 187.67V192.5L703.46 243.41L689.57 251.44L686.04 204.54V199.73C686.04 193.07 690.7 185.02 696.46 181.7C702.2 178.38 706.88 181.06 706.88 187.68L706.89 187.67Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M706.129 128.13C700.599 125.45 691.819 130.65 686.459 139.88L686.399 139.96L686.359 140.02C685.559 141.44 684.829 142.93 684.209 144.48L606.929 338.16C603.399 346.99 604.679 354.19 608.789 356.88L580.539 340.58C576.169 338.06 574.719 330.72 578.329 321.66L655.609 127.98C656.229 126.43 656.949 124.95 657.779 123.52L657.799 123.46L657.859 123.38C663.369 113.91 672.449 108.69 677.939 111.85L706.129 128.14V128.13Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M706.889 268.02C706.889 271.38 705.879 274.79 703.879 278.25C701.879 281.72 699.419 284.32 696.509 285.99C693.619 287.64 691.169 287.91 689.159 286.75C687.179 285.57 686.169 283.32 686.169 279.98C686.169 276.64 687.159 273.21 689.159 269.77C691.159 266.28 693.619 263.74 696.509 262.05C699.419 260.38 701.899 260.09 703.879 261.27C705.879 262.43 706.889 264.7 706.889 268.02Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M686.459 139.88C691.829 130.66 700.609 125.44 706.129 128.13C707.099 128.6 707.979 129.33 708.719 130.34L785.979 234.79C789.509 239.52 788.249 248.2 784.139 255.63",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M608.789 356.87C604.679 354.19 603.399 346.99 606.929 338.15L684.209 144.47C684.829 142.92 685.549 141.44 686.359 140.01L686.399 139.95",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M783.79 256.26C781.25 260.61 777.76 264.53 773.72 266.87L619.21 356.05C615.17 358.4 611.66 358.55 609.14 357.08",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M609.139 357.08L580.539 340.57C576.169 338.05 574.719 330.71 578.329 321.65L655.609 127.97C656.229 126.42 656.949 124.94 657.779 123.51L657.799 123.45L657.859 123.37C663.369 113.9 672.449 108.68 677.939 111.84L706.539 128.35",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M427.369 426.94V497.79L325.169 556.8V485.94L427.369 426.94Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M427.369 426.94L325.169 485.94L293.269 467.53V132.47L395.469 73.4399V408.52L427.369 426.94Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M395.469 516.21V569.35L293.269 628.35V538.38L325.169 556.8L395.469 516.21Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M395.469 73.44L293.269 132.47L219.639 89.9499L321.839 30.95L395.469 73.44Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M325.169 485.94V556.79L293.269 538.37V628.34L225.769 589.38V499.41L96.9492 425.02V354.19L219.639 89.95L293.269 132.47V467.53L325.169 485.95V485.94ZM225.779 428.57V235.17L224.569 234.47L158.309 389.61L225.789 428.57H225.779Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.779 360.66V428.57L158.299 389.61L217.109 355.66L225.779 360.66Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M225.779 235.17V335.35L217.109 355.66L158.299 389.61L224.559 234.47L225.779 235.17Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M225.779 335.35L217.109 355.66L225.779 360.66",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M293.269 628.35L225.779 589.39V499.42L96.959 425.03V354.2L219.639 89.95L293.269 132.47V467.53L325.169 485.94V556.8L293.269 538.38V628.35Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.299 389.61L225.779 428.57V235.17L224.559 234.47L158.299 389.61Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M293.269 132.47L395.469 73.4399",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M325.169 485.94L427.369 426.94",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M325.169 556.8L427.369 497.79V426.94L395.469 408.52V73.44L321.839 30.95L219.639 89.9499",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M293.269 628.35L395.469 569.35V516.21",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M158.299 389.61L217.109 355.66",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M653.489 288.24L551.289 347.25C553.199 355.22 554.679 363.38 555.719 371.73L657.919 312.73C656.879 304.38 655.409 296.21 653.489 288.25V288.24Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M633.439 236.34C615.849 204.48 590.489 178.97 557.359 159.83C525.419 141.39 500.689 137.23 483.219 147.32L381.009 206.33C398.499 196.23 423.219 200.39 455.179 218.85C488.309 237.97 513.659 263.48 531.259 295.34C540.229 311.63 546.909 328.93 551.299 347.24L653.499 288.23C649.109 269.91 642.429 252.61 633.449 236.33L633.439 236.34Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M657.919 312.73L555.719 371.73C556.379 377.04 556.889 382.42 557.209 387.89L659.409 328.89C659.099 323.42 658.589 318.04 657.929 312.73H657.919Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M557.209 387.89C557.489 392.76 557.629 397.69 557.629 402.69V663.38C557.629 703.06 548.819 728.68 531.249 740.24C530.839 740.51 530.429 740.78 529.989 741.04C529.989 741.04 632.819 681.65 633.439 681.24C651.029 669.68 659.819 644.05 659.819 604.38C659.819 604.38 659.679 333.77 659.399 328.89L557.199 387.89H557.209Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M557.629 402.68V663.37C557.629 703.05 548.859 728.72 531.249 740.23C530.839 740.5 530.429 740.77 529.989 741.03L529.329 741.42C511.819 751.52 487.099 747.35 455.159 728.91C422.029 709.77 396.679 684.27 379.099 652.4C361.509 620.52 352.719 584.74 352.719 545.06V284.37C352.719 244.69 361.539 219.13 379.099 207.51C379.719 207.1 380.359 206.7 380.989 206.33C398.469 196.21 423.199 200.39 455.159 218.85C488.289 237.97 513.639 263.48 531.239 295.34C548.809 327.24 557.619 363 557.619 402.68H557.629ZM490.149 629.38V358.77C490.149 340.39 486.449 325.06 479.019 312.76C473.299 303.25 465.339 295.56 455.169 289.69C431.849 276.23 420.209 285.8 420.209 318.38V589.01C420.209 621.59 431.859 644.61 455.169 658.07C478.489 671.53 490.149 661.96 490.149 629.38Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M490.149 601.06C482.719 588.75 479.019 573.42 479.019 555.05V312.76C473.299 303.25 465.339 295.56 455.169 289.69C431.849 276.23 420.209 285.8 420.209 318.38V589.01C420.209 613.61 426.859 632.76 440.159 646.46L490.149 617.6V601.07V601.06Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M440.159 646.45C444.469 650.89 449.459 654.76 455.169 658.06C478.489 671.52 490.149 661.95 490.149 629.37V617.59L440.159 646.45Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M479.019 312.75V555.04C479.019 573.42 482.719 588.75 490.149 601.05",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M529.329 741.43C511.819 751.53 487.099 747.36 455.159 728.92C422.029 709.78 396.679 684.28 379.099 652.41C361.509 620.53 352.719 584.75 352.719 545.07V284.38C352.719 244.7 361.539 219.14 379.099 207.52C379.719 207.11 380.359 206.71 380.989 206.34C398.469 196.22 423.199 200.4 455.159 218.86C488.289 237.98 513.639 263.49 531.239 295.35C548.809 327.25 557.619 363.01 557.619 402.69V663.38C557.619 703.06 548.849 728.73 531.239 740.24C530.829 740.51 530.419 740.78 529.979 741.04",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M479.019 312.75C473.289 303.25 465.339 295.55 455.169 289.68C431.849 276.22 420.209 285.79 420.209 318.37V589C420.209 621.58 431.859 644.6 455.169 658.06C478.489 671.52 490.149 661.95 490.149 629.37V358.76C490.149 340.38 486.439 325.06 479.019 312.75Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M380.999 206.33L483.209 147.32C500.679 137.24 525.419 141.39 557.349 159.83C590.479 178.97 615.829 204.49 633.429 236.34C651.019 268.22 659.809 304 659.809 343.68V604.37C659.809 644.05 650.989 669.61 633.429 681.23C632.809 681.64 632.169 682.03 631.519 682.42L529.329 741.42",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M917.479 709.92V780.77L815.289 839.77V768.92L917.479 709.92Z",
    fill: "#459AA4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M917.479 709.92L815.289 768.92L783.389 750.5V415.42L885.589 356.42V691.5L917.479 709.92Z",
    fill: "#459AA4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M885.589 799.19V852.32L783.389 911.32V821.35L815.289 839.77L885.589 799.19Z",
    fill: "#459AA4"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M885.589 356.42L783.389 415.42L709.779 372.93L811.979 313.93L885.589 356.42Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M815.289 768.92V839.77L783.389 821.35V911.32L715.909 872.34V782.37L587.069 708V637.15L709.779 372.92L783.389 415.41V750.49L815.289 768.91V768.92ZM715.919 711.55V518.15L714.689 517.45L648.429 672.59L715.929 711.55H715.919Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M715.919 643.64V711.55L648.419 672.59L707.229 638.64L715.919 643.64Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M715.919 518.15V618.32L707.229 638.64L648.419 672.59L714.679 517.45L715.919 518.15Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M715.919 618.32L707.229 638.64L715.919 643.64",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M783.389 911.32L715.919 872.35V782.38L587.069 708.01V637.15L709.779 372.93L783.389 415.42V750.5L815.289 768.92V839.77L783.389 821.35V911.32Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M648.419 672.59L715.919 711.55V518.15L714.679 517.45L648.419 672.59Z",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M783.389 415.42L885.589 356.42",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M815.289 768.92L917.479 709.92",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M815.289 839.77L917.479 780.77V709.92L885.589 691.5V356.42L811.979 313.93L709.779 372.93",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M783.389 911.32L885.589 852.32V799.19",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M648.419 672.59L707.229 638.64",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7793 705.54L200.759 463.6",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M164.639 740.91L265.309 499.69",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M185.409 691.15L120.849 655.06",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M204.419 645.58L139.869 609.49",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M223.439 600.01L158.889 563.92",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M242.459 554.44L177.909 518.34",
    stroke: "white",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Dark);
export default __webpack_public_path__ + "static/media/404Dark.4a13043c418f9fdaeaf7b6bfba6c4ae7.svg";
export { ForwardRef as ReactComponent };